<template>
  <v-row justify="center">
    <v-dialog
      v-model="show"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5">
          Motivo da rejeição
        </v-card-title>
        <v-container fluid>
          <v-textarea
            :rules="obrigatoryRules"
            clearable
            clear-icon="mdi-close-circle"
            label="Texto para e-mail:"
            v-model="message"
          ></v-textarea>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="show = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="alterStatus"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    data: () => ({
      obrigatoryRules: [
        v => !!v || 'Informação obrigatória'
      ]
    }),
    props: {
      showModalReject: false,
      emailMessageReject: null
    },
    methods: {
      async alterStatus () {
        this.$emit('alter-status')
      }
    },
    computed: {
      show: {
        get () {
          return this.showModalReject
        },
        set (value) {
          this.$emit('update:showModalReject', value)
        }
      },
      message: {
        get () {
          return this.emailMessageReject
        },
        set (value) {
          this.$emit('update:emailMessageReject', value)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/modals/RejectModal.vue